<template>
    <el-container style="position: relative;background: #fff">
        <!-- 头部 -->
        <school-header />
        <router-view />
        <!-- 底部 -->
       <infor-footer />
    </el-container>
</template>
<script>

    import SchoolHeader from "./components/SchoolHeader"
    import InforFooter from "./components/InforFooter"

    export default {
        components: {
            SchoolHeader,
            InforFooter
        },
        created() {},
        data: () => {
            return {}
        },
        mounted() {},

        computed: {},

        watch: {},
    }
</script>

